module.exports = __webpack_public_path__ + "img/setor_atas_encaminhamentos.cfd5f486.png";